module.exports = __webpack_public_path__ + "img/role02.8c2c876e.png";